import type { CreateExportResponse, ExportBatchSummary, ExportFilters } from "@crewledger/shared/schemas";
import { apiFetch, downloadAuthenticatedFile } from "@/lib/api";

export async function fetchExportBatches(params?: {
  page?: number;
  pageSize?: number;
  status?: string;
  exportKind?: string;
}) {
  const search = new URLSearchParams();
  if (params?.page) search.set("page", String(params.page));
  if (params?.pageSize) search.set("pageSize", String(params.pageSize));
  if (params?.status) search.set("status", params.status);
  if (params?.exportKind) search.set("exportKind", params.exportKind);
  const qs = search.toString();
  return apiFetch<{ data: ExportBatchSummary[]; meta: { total?: number } }>(
    `/api/exports${qs ? `?${qs}` : ""}`,
  );
}

export async function queuePayrollExport(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/payroll", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queueSiteCostExport(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/site-cost", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queueEquipmentExport(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/equipment", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queueExceptionsExport(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/exceptions", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queueAuditExport(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/audit", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queuePayPeriodSummaryPdf(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/pdf/pay-period-summary", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queueSiteCostPdf(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/pdf/site-cost", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queueWorkerDetailPdf(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/pdf/worker-detail", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export async function queueEquipmentUsagePdf(filters: ExportFilters = {}) {
  return apiFetch<{ data: CreateExportResponse }>("/api/exports/pdf/equipment-usage", {
    method: "POST",
    body: JSON.stringify(filters),
  });
}

export function buildExportDownloadPath(exportBatchId: string): string {
  return `/api/exports/${exportBatchId}/download`;
}

export async function downloadExportBatch(
  exportBatchId: string,
  fallbackFileName = "werkio-export.csv",
): Promise<void> {
  await downloadAuthenticatedFile(buildExportDownloadPath(exportBatchId), fallbackFileName);
}

